<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
                <!-- 左侧竖向步骤条 -->
                <div style="width: 240px; min-width: 220px; margin-right: 24px;">
                    <el-steps direction="vertical" :active="activeValue">
                <el-step v-for="(itemf, index) of activeList"
            :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                  <template slot="description">
                    <div v-if="itemf.processNodeName === '制单人'">
                      {{ itemf.approvalTime }}
                    </div>
                    <div v-else>
                      <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                      <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                      <div>经办人：{{ itemf.maker || '' }}</div>
                      <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                      <div>时间：{{ itemf.makerTime || '' }}</div>
                    </div>
                  </template>
                </el-step>
            </el-steps>
                </div>
                <!-- 右侧内容 -->
                <div style="flex: 1; overflow-x: auto;">
            <Boyo-Formtwo :formInfo="formInfo2"
                    :refObj.sync="formInfo2.ref"
                    :listTypeInfo='listTypeInfo'
                    @handlePictureCardPreview="handlePictureCardPreview">
            </Boyo-Formtwo>
            <el-table :data="tableData"
                    border
                    :summary-method="getSummaries"
                    show-summary
                    max-height="430"
                    style="width: 99%;"
                    :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                    :cell-style="{padding:'2px'}">
                    <el-table-column fixed="left"
                    type="index"
                    width="50">
                    </el-table-column>
                <el-table-column prop="carNo"
                                align="center"
                                label="车号" width='80px'>
                </el-table-column>
                <el-table-column prop="driver"
                                align="center"
                                label="司机" width='90px'>
                </el-table-column>
                <el-table-column prop="materialNo" align="center" width="90px"
                                label="物料编号">
                </el-table-column>
                <el-table-column prop="materialName"
                                label="物料名称"
                                align="center"
                                width="200px">
                </el-table-column>
                <el-table-column prop="materialSpec" align="center" width="100px"
                                label="物料规格">
                </el-table-column>
                <el-table-column prop="quantity"
                                align="center"
                                label="数量" width="90px">
                </el-table-column>
                <el-table-column prop="unit"
                                align="center"
                                label="单位" width='90px'>
                </el-table-column>
                <el-table-column prop="remark"
                                align="center"
                                label="备注">
                </el-table-column>
            </el-table>
                <!-- 审核表单 -->
                <div v-if="showAuditForm" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                   <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfoAudit"
                             :refObj.sync="formInfoAudit.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
                </div>
            </div>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'WorkContactLetterDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '工作联络函'
        ],
        showPhraseManager: false,
        newPhrase: '',
      // 下拉框相关信息
      listTypeInfo: {
        purMode :[],
        processId:[],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
      },
      // 审核表单相关
      formInfoAudit: {
        ref: null,
        labelWidth: '100px',
        data: {
          status: '',
          remark: '',
          processId:'',
        },
        list: [
        { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
        { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
        { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status:[{ required: true, trigger: 'change',message: '请选择' }]
        }
      },
      showAuditForm: false,
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          
          id: null,
          fileName:'',
          applicantDeptId:'',
          applicantDept:'',
          sectionId:'',
          sectionName:'',
          receiveDeptId:'',
          receiveDept:'',
          applicant:'',
          employeeId:'',
          applicantPhone:'',
          timeReq:'',
          relatedAccessories:'',
          documentNumberType:'',
          documentNumber:'',
          text:'',
          textAbstract:'',
        },
        list: [
          {type: "text",label: "文件名称：",value: "fileName", style: 'width:99%', className: 'form_item_one',disabled:true},
          {type: "text",label: "申请人：",value: "applicant", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "联系电话：",value: "applicantPhone",labelContent:'申请人联系电话', style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "申请部门：",value: "applicantDept", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "所属科室：",value: "sectionName", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "文号类型：",value: "documentNumberType", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "文号：",value: "documentNumber", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "date",label: "时间要求：",value: "timeReq", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "接收部门：",value: "receiveDept", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "textarea",label: "正文：",value: "text", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "textarea",label: "正文摘要：",value: "textAbstract", style: 'width:95%', className: 'form_item_two',disabled:true},
          { type: 'uploadThree', label: '相关附件：', value: 'relatedAccessories', style: 'width:95%;', className: 'form_item_one',fileListHt:[],disabled:true },
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '工作联络函对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
      createdBy: null,
      createdTime: null,
    }
  },
  created () {
  },
  mounted () {
     // 获取流程枚举
     this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for( let i in list1 ) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime) {
        this.billId = data
        this.dataId = id
        // 保存制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        if (parm && parm.processId) {
            this.auditParm = parm
            this.dialogInfoData.btList[0].show = true
            // 显示审核表单并初始化
            this.showAuditForm = true
            this.formInfoAudit.data.status = 1
            this.formInfoAudit.data.remark = ''
            // 流程名称回显逻辑
            // 先确保流程枚举已加载
            // 1. 先声明一个函数，用来把原始值转成 label
            const setProcessLabel = () => {
            const list = this.listTypeInfo.processId || [];
            const hit  = list.find(i => i.enumValue === parm.processId);
              this.formInfoAudit.data.processId = hit ? hit.label : parm.processId;
            };
            // 2. 如果已经回来了就直接用；否则用 watch 等它
            if (this.listTypeInfo.processId && this.listTypeInfo.processId.length) {
              this.$nextTick(setProcessLabel);       // 立刻跑
            } else {
              const unwatch = this.$watch(
              () => this.listTypeInfo.processId,   // 监听数组
              val => {
                if (Array.isArray(val) && val.length) {
                  unwatch();                       // 只用一次就解绑
                  setProcessLabel();
                }
              },
              { immediate: true }
            );

          }
        } else {
            this.dialogInfoData.btList[0].show = false
            this.showAuditForm = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo(val) {
        this.$api.system.getActProcessEntryPage({ idProcessInstance: this.dataId, pageNum: 1, pageSize: 999 }).then(res => {
            if (res.code == 0) {
                this.activeList = []
                this.activeValue = 0
                for (let i in res.data.list) {
                    if (res.data.list[i].status && i < res.data.list.length) {
                        this.activeValue = Number(Number(i) + 1)
                    }
                    let stepStatus = 'process';
                    if (res.data.list[i].status == 1) {
                        stepStatus = 'success';
                    } else if (res.data.list[i].status == 2) {
                        stepStatus = 'error';
                    } else {
                        stepStatus = 'process';
                    }
                    this.activeList.push({
                      processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                      maker: res.data.list[i].status
                        ? res.data.list[i].actualApprover
                        : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                      remark: res.data.list[i].remark || '', // 第三行：备注
                      makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                      stepStatus
                    })
                }
                // 步骤条最前面插入“制单人”节点
                let maker = this.createdBy || '暂无';
                let makerTime = this.createdTime || '';
                let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
                this.activeList.unshift({ processNodeName: '制单人', approvalTime });
                this.activeValue = (this.activeValue || 0) + 1;
            } else {
                this.$message({ message: res.msg, type: "error" });
            }
        })
      this.$api.OrderPurchase.getStkContactLetterPage({id:this.billId,pageNum:1,pageSize:0}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  this.formInfo2.data[key] = ''
                }
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                if (this.formInfo2.list[this.formInfo2.list.length - 1]) {
                  this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = []
                  if (this.detailDate.relatedAccessories) {
                    this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = [{name: (this.detailDate.relatedAccessories.split('-').length > 2)?this.detailDate.relatedAccessories.split('-')[2]:this.detailDate.relatedAccessories.split('-')[1],url: this.detailDate.relatedAccessories}]
                  }
                }
                this.$api.OrderPurchase.getStkContactLetterEntryPage({idStkContactLetter:this.detailDate.id,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data.list
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              if(this.showAuditForm){
                this.formInfoAudit.ref.validate(valid => {
                  if(valid){
                    let parma = this.auditParm
                    this.$api.system.approval({id:parma.id,processId:parma.processId,status:this.formInfoAudit.data.status,remark:this.formInfoAudit.data.remark}).then(res => {
                        if (res.code === 0) {
                            this.$message({ message: res.msg, type: 'success' })
                            dialogInfoData.visible = false
                            this.$emit('approvalInfo')
                        } else {
                            this.$message({ message: res.msg, type: 'error' })
                        }
                    })
                  }
                })
              }else{
                dialogInfoData.visible = false
              }
              break
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    getSummaries (param) {
      //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        for(let i=0; i<100;i++){
          if(sums[i]==0){
            sums[i]=''
          }
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property === 'baseQuantity'|| column.property === 'purMoney' || column.property === 'purExctTaxMoney' || column.property === 'carNetWeight' || column.property === 'carDeductWeight' || column.property === 'settleQuantity' || column.property === 'settleExctTaxAmount' || column.property === 'settleAmount') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index]?this.formatAmount(Number(sums[index].toFixed(3))):'';
        }
      });
      this.$emit('getSummaries', sums)
      return sums;
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/WorkContactLetterDialog.vue